export default "__VITE_ASSET__CciOMqMu__"